
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { pointCalculator } = api;

@Component
export default class PointCalculatorList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private panel = 0;

  private loading = false;

  private headers = [
    { text: '名稱', value: 'name' },
    { text: '點數有效期限文字說明', value: 'expiredTime' },
    { text: '匯率', value: 'rate' },
    { text: '集氣進度', value: 'numberOfWishes' },
    { text: '修改', value: 'actions' },
    { text: '啟用', value: 'isEnabled', width: 70 },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    q: this.$route.query.q || undefined,
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      q: this.filter.q,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      pageSize: 20,
      pageNo: 1,
      q: undefined,
    };
    await this.query();
  }

  private async changeEnableStatus(id: string, isEnabled: boolean) {
    const word = isEnabled ? '停用' : '啟用';
    await Swal.fire({
      title: `您確定要${word}嗎?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then(async ({ isConfirmed }) => {
      if (isConfirmed) {
        const { status, message } = isEnabled
          ? await pointCalculator.disable(id)
          : await pointCalculator.enable(id);
        if (status) {
          await Swal.fire({ icon: 'success', title: `${word}成功` });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: message });
        }
      }
    });
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await pointCalculator.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async created() {
    await this.requestData();
  }
}
